import {
    API_SEND_FREE_CODE,
    API_EVENTS,
    API_BOOKING_BY_CODE,
    API_CANCEL_TICKET,
    API_EVENTDATE,
    API_EVENTDATE_START,
    API_JOIN_EVENTDATE,
    } from 'config/nw-api';
import axios from "axios";

function getAllWithDates(data) {
    return axios.get(API_EVENTS, {params: data});
}

function getEventDate(data) {
    return axios.get(API_EVENTDATE.replace(':code', data.code),{params: {scid: data.scid}});
}

async function reserveTicket(data) {
    return await axios.post(API_BOOKING_BY_CODE, data);
}

async function freeCode(data) {
    return await axios.post(API_SEND_FREE_CODE, data);
}

async function cancelTicket(id, data) {
    return await axios.put(API_CANCEL_TICKET.replace(':id', id), data);
}

function checkDateStartSoon(data) {
    return axios.get(API_EVENTDATE_START.replace(':eventDateId', data.eventDateId)?.replace(':ticketId', data.ticketId));
}

function joinEventDate(data) {
    return axios.put(API_JOIN_EVENTDATE.replace(':eventDateId', data.eventDateId)?.replace(':ticketId', data.ticketId));
}

const EVENTS_API = {
    getAllWithDates,
    reserveTicket,
    cancelTicket,
    getEventDate,
    freeCode,
    checkDateStartSoon,
    joinEventDate,
};

export default EVENTS_API;

